const selectorStyles = ({ spacing, tabs }) => ({
  '& button': {
    '&.active': {
      '&:hover': {
        color: tabs.activeColor,
      },
      borderBottom: `1px solid ${tabs.activeColor}`,
      color: tabs.activeColor,
    },
    '&:hover': {
      color: tabs.hoverColor,
    },
    background: 'transparent',
    border: 'none',
    borderRadius: 0,
    color: tabs.color,
    fontFamily: tabs.fontFamily,
    fontSize: tabs.fontSize,
    fontWeight: tabs.fontWeight,
    lineHeight: '38px',
    marginRight: spacing.xs,
    outline: 'none',
    padding: 0,
    verticalAlign: 'middle',
  },
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
});

export default selectorStyles;
